import { createContext, useContext, useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";

const LenisCtx = createContext(null);
export const useLenis = () => useContext(LenisCtx);

export const SmoothScroll = ({ children }) => {
  const [lenis, setLenis] = useState(null);
  const raf = useRef(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const l = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(l);
    const loop = (t) => { l.raf(t); raf.current = requestAnimationFrame(loop); };
    raf.current = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf.current); l.destroy(); };
  }, []);

  return <LenisCtx.Provider value={lenis}>{children}</LenisCtx.Provider>;
};

export const scrollToId = (lenis, id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -90 });
  else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 90, behavior: "smooth" });
};

export const ScrollManager = () => {
  const { pathname, hash, search } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(lenis, hash.slice(1)), 120);
      return () => clearTimeout(t);
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash, search, lenis]);
  return null;
};
